import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AudiLogo from './AudiLogo';

const { FiMenu, FiX, FiPhone } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Models', href: '/models' },
    { name: 'Build Your Audi', href: '/build-your-audi' },
    { name: 'Inventory', href: '/inventory' },
    { name: 'Services', href: '/services' },
    { name: 'Parts', href: '/parts' },
    { name: 'Financing', href: '/financing' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-lg sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <AudiLogo />
            <div className="flex flex-col">
              <span className="text-xl font-light text-gray-900 uppercase tracking-wider">
                Halifax Audi
              </span>
              <span className="text-xs text-gray-500 -mt-1">Halifax, NS</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-3 py-2 text-sm font-medium transition-colors duration-200 uppercase tracking-wider ${
                  isActive(item.href)
                    ? 'text-red-600 border-b-2 border-red-600'
                    : 'text-gray-700 hover:text-red-600'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Contact Info */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm">
              <SafeIcon icon={FiPhone} className="w-4 h-4 text-red-600" />
              <span className="text-gray-700">(902) 455-7890</span>
            </div>
            <Link
              to="/contact"
              className="bg-red-600 text-white px-4 py-2 text-sm font-medium hover:bg-red-700 transition-colors duration-200 uppercase tracking-wider"
            >
              Schedule Test Drive
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-700 hover:text-red-600 hover:bg-gray-100"
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden border-t border-gray-200"
          >
            <div className="py-4 space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block px-3 py-2 text-base font-medium transition-colors duration-200 uppercase tracking-wider ${
                    isActive(item.href)
                      ? 'text-red-600 bg-gray-50'
                      : 'text-gray-700 hover:text-red-600 hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-4 border-t border-gray-200">
                <div className="flex items-center space-x-2 px-3 py-2 text-sm">
                  <SafeIcon icon={FiPhone} className="w-4 h-4 text-red-600" />
                  <span className="text-gray-700">(902) 455-7890</span>
                </div>
                <Link
                  to="/contact"
                  onClick={() => setIsMenuOpen(false)}
                  className="block mx-3 mt-2 bg-red-600 text-white px-4 py-2 text-sm font-medium text-center hover:bg-red-700 transition-colors duration-200 uppercase tracking-wider"
                >
                  Schedule Test Drive
                </Link>
              </div>
            </div>
          </motion.div>
        )}
      </div>
    </header>
  );
};

export default Header;